import { defineStore } from "pinia";
import API from "../api/index.js";

export const useSubjectsStore = defineStore('subjects', {
   state: () => ({

     subjects: [],
   
    }),
 
   actions: {
      async fetch_subjects() {
        const res = await API.fetch_subjects();
        this.subjects = res.data || [];
      },
      
      add_subject_to_store(new_subject) {
        this.subjects.push(new_subject);
      },
      
      update_subject_in_store(updated_subject) {
        const index = this.subjects.findIndex(s => s.id === updated_subject.id);
        if (index !== -1) {
          this.subjects[index] = { ...this.subjects[index], ...updated_subject };
        }
      },
      
      remove_subject_from_store(id) {
        this.subjects = this.subjects.filter(s => s.id !== id);
      }
   },
})